/**
 * Default household avatar emoji rendered when the user has not chosen one yet.
 * Centralized here because it used to drift between AppShell and the Settings
 * pages (see PR-80). Keep as a single source of truth.
 */
export const DEFAULT_HOUSEHOLD_EMOJI = '🏡';
